import { useRecords } from '@puzzlehq/sdk';
import { RecordStatus } from '@puzzlehq/types';
import {
  COIN_CONTRACT,
  COIN_RECORD_NAME,
  TICKET_CONTRACT,
  TICKET_RECORD_NAME,
} from '../utils.js';

export const useArcadeRecords = () => {
  const {
    records: parcRecordsUnspent,
    loading: parcRecordsUnspentLoading,
    error: parcRecordsUnspentError,
  } = useRecords({
    filter: {
      programIds: [COIN_CONTRACT].filter((c) => c !== undefined),
      status: RecordStatus.Unspent,
      names: [COIN_RECORD_NAME],
    },
  });

  const {
    records: parcRecordsPending,
    loading: parcRecordsPendingLoading,
    error: parcRecordsPendingError,
  } = useRecords({
    filter: {
      programIds: [COIN_CONTRACT].filter((c) => c !== undefined),
      status: RecordStatus.Pending,
      names: [COIN_RECORD_NAME],
    },
  });

  const {
    records: partRecordsUnspent,
    loading: partRecordsUnspentLoading,
    error: partRecordsUnspentError,
  } = useRecords({
    filter: {
      programIds: [TICKET_CONTRACT].filter((c) => c !== undefined),
      status: RecordStatus.Unspent,
      names: [TICKET_RECORD_NAME],
    },
  });

  const {
    records: partRecordsPending,
    loading: partRecordsPendingLoading,
    error: partRecordsPendingError,
  } = useRecords({
    filter: {
      programIds: [TICKET_CONTRACT].filter((c) => c !== undefined),
      status: RecordStatus.Pending,
      names: [TICKET_RECORD_NAME],
    },
  });

  return {
    parcRecordsUnspent,
    parcRecordsPending,
    partRecordsUnspent,
    partRecordsPending,
    loading:
      parcRecordsPendingLoading ||
      parcRecordsUnspentLoading ||
      partRecordsPendingLoading ||
      partRecordsUnspentLoading,
    error:
      parcRecordsUnspentError ??
      parcRecordsPendingError ??
      partRecordsUnspentError ??
      partRecordsPendingError,
  };
};
